// TenantLogin.styles.js
// Styles for Tenant Login Portal

import theme from '../../theme';

const TenantLoginStyles = {
    container: {
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.colors.black} 0%, ${theme.colors.darkGray} 100%)`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
    },
    paper: {
        padding: '48px 40px',
        maxWidth: '440px',
        width: '100%',
        backgroundColor: theme.colors.extraLightGray,
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
    },
    logo: {
        height: 100,
        width: 'auto',
        marginBottom: '16px',
        display: 'block',
    },
    title: {
        color: theme.colors.black,
        fontWeight: 600,
        marginBottom: '8px',
    },
    subtitle: {
        color: theme.colors.mediumGray,
        marginBottom: '24px',
    },
    form: {
        marginTop: '16px',
        width: '100%',
    },
    textField: {
        marginBottom: '16px',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
        },
    },
    primaryButton: {
        marginTop: '16px',
        marginBottom: '16px',
        padding: '12px',
        borderRadius: '8px',
        backgroundColor: theme.colors.green,
        color: theme.colors.white,
        fontWeight: 600,
        fontSize: '16px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.colors.greenHover || '#6aa832',
        },
        '&:disabled': {
            backgroundColor: theme.colors.lightGray,
        },
    },
    secondaryButton: {
        marginTop: '8px',
        padding: '12px',
        borderRadius: '8px',
        border: `1px solid ${theme.colors.green}`,
        color: theme.colors.green,
        fontWeight: 600,
        fontSize: '16px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'rgba(129, 194, 65, 0.08)',
        },
    },
    divider: {
        margin: '24px 0',
        color: theme.colors.mediumGray,
    },
    linkText: {
        marginTop: '16px',
        color: theme.colors.mediumGray,
        textAlign: 'center',
    },
    link: {
        color: theme.colors.green,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    errorAlert: {
        marginBottom: '16px',
        borderRadius: '8px',
    },
    successAlert: {
        marginBottom: '16px',
        borderRadius: '8px',
    },
    infoBox: {
        backgroundColor: 'rgba(129, 194, 65, 0.08)',
        padding: '16px',
        borderRadius: '8px',
        marginTop: '16px',
        border: '1px solid rgba(129, 194, 65, 0.3)',
    },
    priceHighlight: {
        color: theme.colors.green,
        fontWeight: 700,
        fontSize: '24px',
    },
};

export default TenantLoginStyles;
